export default "__VITE_ASSET__BjtND_d7__"